module.exports = __webpack_public_path__ + "static/media/illustration_landing-icons.93604041.svg";